<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        @click="activeCreatePrompt = true"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Создать голосование</vs-button
      >
    </vs-row>
    <vx-card title="Таблица голосований" class="p-6">
      <vs-table
        :data="votings"
        :stripe="true"
        :search="true"
        :pagination="true"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Тема </vs-th>
          <vs-th> Дата создания </vs-th>
          <vs-th> Суть проблемы </vs-th>
          <vs-th> Бюджет </vs-th>
          <vs-th> Источник финансирования </vs-th>
          <vs-th> Сроки </vs-th>
          <vs-th> Результаты </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].title">
              {{ data[indextr].title }}
            </vs-td>

            <vs-td :data="data[indextr].date_created">
              {{ data[indextr].date_created }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>

            <vs-td :data="data[indextr].budget">
              {{ data[indextr].budget }}
            </vs-td>

            <vs-td :data="data[indextr].finance_source">
              {{ data[indextr].finance_source }}
            </vs-td>

            <vs-td :data="data[indextr].date_predicted">
              {{ data[indextr].date_predicted }}
            </vs-td>

            <vs-td>
              <p class="mb-2">
                Всего голосов:
                <span class="color-primary">{{
                  data[indextr].total_votes
                }}</span>
              </p>
            </vs-td>

            <vs-td :data="!data[indextr].is_archive ? 'Активно' : 'Закрыто'">
              {{ !data[indextr].is_archive ? "Активно" : "Закрыто" }}
            </vs-td>

            <vs-td>
              <vx-tooltip
                class="inline-block"
                text="Открыть подробную статистику"
              >
                <vs-button
                  @click="openStatistics(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>

              <vx-tooltip class="inline-block" text="Подвести итоги">
                <vs-button
                  v-if="!data[indextr].is_archive"
                  @click="openResult(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-flag"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>

              <vx-tooltip class="inline-block" text="Удалить голосование">
                <vs-button
                  @click="openModalDeleteVoting(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup
      title="Создать голосование"
      :active.sync="activeCreatePrompt"
      :button-close-hidden="true"
    >
      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        data-vv-validate-on="blur"
        label="Тема голосования"
        name=""
        v-model="newVoting.title"
      />

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        data-vv-validate-on="blur"
        label="Суть проблемы"
        name=""
        v-model="newVoting.description"
      />

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        data-vv-validate-on="blur"
        label="Бюджет"
        name=""
        v-model.number="newVoting.budget"
        type="number"
      />

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        data-vv-validate-on="blur"
        label="Источник финансирования"
        name=""
        v-model="newVoting.finance_source"
      />

      <label class="vs-input--label">Дата</label>
      <datepicker
        :language="languageDatePicker"
        :inline="true"
        :disabled-dates="disabledDates"
        class="w-full mb-4"
        name="Дата"
        data-vv-validate-on="blur"
        v-validate="'required'"
        placeholder="Дата"
        v-model="newVoting.date_predicted"
      >
      </datepicker>

      <vs-checkbox class="mb-4" v-model="newVoting.is_auto_result"
        >Автоматическое подведение итогов</vs-checkbox
      >

      <template v-if="newVoting.is_auto_result">
        <label class="vs-input--label">Дата подведения итогов</label>
        <flat-pickr
          class="block w-full"
          :config="configdateTimePicker"
          v-model="newVoting.date_end"
        />
      </template>

      <vs-divider />

      <div>
        <p>Варианты ответов:</p>
        <div
          class="wrap flex items-center"
          v-for="(answer, index) in newVoting.answers"
          v-bind:key="index"
        >
          <vs-input
            class="mb-4 mr-4 w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :label="`Вариант ответа #${index + 1}`"
            name=""
            v-model="newVoting.answers[index]"
          />
          <vs-button
            radius
            @click="removeNewAnswer(index)"
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-x"
          ></vs-button>
        </div>

        <vs-button
          radius
          v-if="countNewAnswers < 5"
          @click="addNewAnswer"
          class="mx-auto"
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-plus"
        ></vs-button>
      </div>

      <div class="popup-footer mt-4">
        <vs-button
          @click="createVoting"
          :disabled="countNewAnswers < 2"
          class="mr-5"
          ref="loadableButton"
          type="relief"
          vslor="primary"
          >Создать</vs-button
        >
        <vs-button @click="clearNewVoting" color="dark" type="border"
          >Отмена</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      title="Подробная статистика голосования"
      :active.sync="activeStatisticsPrompt"
    >
      <h4 class="mb-6">Тема голосования: "{{ infoStatisticsData.title }}"</h4>
      <p v-if="infoStatisticsData.description" class="mb-6">
        Суть проблемы:
        <span class="font-semibold">{{ infoStatisticsData.description }}</span>
      </p>
      <p v-if="infoStatisticsData.budget" class="mb-6">
        Бюджет:
        <span class="font-semibold">{{ infoStatisticsData.budget }}</span>
      </p>
      <p v-if="infoStatisticsData.finance_source" class="mb-6">
        Источник финансирования:
        <span class="font-semibold">{{
          infoStatisticsData.finance_source
        }}</span>
      </p>
      <p v-if="infoStatisticsData.date_predicted" class="mb-6">
        Дата исполнения:
        <span class="font-semibold">{{
          infoStatisticsData.date_predicted
        }}</span>
      </p>
      <p class="mb-6">
        Автоматическое подведение итогов:
        <span class="font-semibold">{{
          infoStatisticsData.is_auto_result ? "Да" : "Нет"
        }}</span>
      </p>
      <p v-if="infoStatisticsData.date_end" class="mb-6">
        Дата подведения итогов:
        <span class="font-semibold">{{
          formatDateTime(infoStatisticsData.date_end)
        }}</span>
      </p>

      <vs-divider />

      <div v-for="answer in infoStatisticsData.answers">
        <div class="flex justify-between">
          <div class="flex flex-col">
            <span class="mb-1">{{ answer.text }}</span>
            <h4>
              {{
                infoStatisticsData.total_votes !== 0
                  ? Math.floor(
                      (answer.votes_number * 100) /
                        infoStatisticsData.total_votes
                    )
                  : 0
              }}
              % <span class="text-base">({{ answer.votes_number }})</span>
            </h4>
          </div>
        </div>
        <vs-progress
          :percent="
            infoStatisticsData.total_votes !== 0
              ? Math.floor(
                  (answer.votes_number * 100) / infoStatisticsData.total_votes
                )
              : 0
          "
          color="primary"
        ></vs-progress>

        <template v-if="answer.votes_number > 0">
          <h5 class="mt-4 mb-3">Список проголосовавших:</h5>
          <ul>
            <li
              class="text-primary mb-3"
              v-for="(user, index) in answer.votes"
              :key="index"
            >
              {{ user.user.full_name }}
            </li>
          </ul>
        </template>
        <vs-divider />
      </div>

      <template
        v-if="
          infoStatisticsData.total_votes === 0 && infoStatisticsData.is_archive
        "
      >
        <h3 class="text-primary">Результат: Нет проголосовавших</h3>
      </template>
      <template
        v-else-if="
          infoStatisticsData.total_votes > 0 && infoStatisticsData.is_archive
        "
      >
        <h3 class="text-primary mb-4">
          Результат: {{ infoStatisticsData.result }}% проголосовало за вариант
          "{{ infoStatisticsData.solution }}"
        </h3>
      </template>
    </vs-popup>

    <vs-popup title="Решение" :active.sync="activeResultPrompt">
      <h4 class="mb-6">Тема голосования: "{{ infoStatisticsData.title }}"</h4>
      <p v-if="infoStatisticsData.description" class="mb-6">
        Суть проблемы:
        <span class="font-semibold">{{ infoStatisticsData.description }}</span>
      </p>
      <p v-if="infoStatisticsData.budget" class="mb-6">
        Бюджет:
        <span class="font-semibold">{{ infoStatisticsData.budget }}</span>
      </p>
      <p v-if="infoStatisticsData.finance_source" class="mb-6">
        Источник финансирования:
        <span class="font-semibold">{{
          infoStatisticsData.finance_source
        }}</span>
      </p>
      <p v-if="infoStatisticsData.date_predicted" class="mb-6">
        Дата исполнения:
        <span class="font-semibold">{{
          infoStatisticsData.date_predicted
        }}</span>
      </p>
      <p class="mb-6">
        Автоматическое подведение итогов:
        <span class="font-semibold">{{
          infoStatisticsData.is_auto_result ? "Да" : "Нет"
        }}</span>
      </p>
      <p v-if="infoStatisticsData.date_end" class="mb-6">
        Дата подведения итогов:
        <span class="font-semibold">{{
          formatDateTime(infoStatisticsData.date_end)
        }}</span>
      </p>

      <vs-divider />

      <div v-for="answer in infoStatisticsData.answers">
        <div class="flex justify-between">
          <div class="flex flex-col">
            <span class="mb-1">{{ answer.text }}</span>
            <h4>
              {{
                infoStatisticsData.total_votes !== 0
                  ? Math.floor(
                      (answer.votes_number * 100) /
                        infoStatisticsData.total_votes
                    )
                  : 0
              }}
              % <span class="text-base">({{ answer.votes_number }})</span>
            </h4>
          </div>
        </div>
        <vs-progress
          :percent="
            infoStatisticsData.total_votes !== 0
              ? Math.floor(
                  (answer.votes_number * 100) / infoStatisticsData.total_votes
                )
              : 0
          "
          color="primary"
        ></vs-progress>

        <template v-if="answer.votes_number > 0">
          <h5 class="mt-4 mb-3">Список проголосовавших:</h5>
          <ul>
            <li
              class="text-primary mb-3"
              v-for="(user, index) in answer.votes"
              :key="index"
            >
              {{ user.user.full_name }}
            </li>
          </ul>
        </template>
      </div>

      <vs-divider />

      <template v-if="infoStatisticsData.total_votes === 0">
        <h3 class="text-primary">Результат: Нет проголосовавших</h3>
      </template>
      <template
        v-if="
          infoStatisticsData.total_votes !== 0 && resultStatisticsData !== null
        "
      >
        <h3 class="text-primary mb-4">
          Результат: {{ resultStatisticsData.percent }}% проголосовало за
          вариант "{{ resultStatisticsData.text }}"
        </h3>

        <vs-button
          v-if="resultStatisticsData.percent > 0"
          @click="closeVoting"
          color="primary"
          type="filled"
          >Закрыть голосование
        </vs-button>
      </template>
    </vs-popup>

    <vs-popup
      v-if="votingDelete !== null"
      title="Вы действительно хотите удалить?"
      :active.sync="activeDeletePrompt"
    >
      <p class="font-semibold mb-5">
        Голосование
        <span class="text-danger text-lg">{{ votingDelete.title }}</span>
        будет удалено безвозвратно
      </p>
      <vs-button @click="deleteVoting" color="danger" class="mr-5" type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="activeDeletePrompt = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { API_URL } from "@/.env";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

export default {
  data: () => ({
    votings: [],
    newVoting: {
      title: "",
      description: "",
      budget: 0,
      finance_source: "",
      date_predicted: "",
      answers: [],

      date_end: "",
      is_auto_result: false,
    },
    BASE_URL: API_URL,

    activeCreatePrompt: false,
    activeStatisticsPrompt: false,
    activeResultPrompt: false,

    answersStatisticsData: null,
    totalStatisticsData: 0,
    titleStatisticsData: "",
    countNewAnswers: 0,

    infoStatisticsData: {},
    resultStatisticsData: null,

    languageDatePicker: ru,
    disabledDates: {
      to: ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date()),
    },

    configdateTimePicker: {
      enableTime: true,
      dateFormat: "d.m.Y H:i",
      noCalendar: false,
      time_24hr: true,
      locale: RussianLocale,
      minDate: "today",
      minuteIncrement: 10,
    },

    resultData: [
      { id: "solid", name: "единогласно" },
      { id: "2out3", name: "2/3" },
      { id: "3out4", name: "3/4" },
      { id: "50to50", name: "50/50" },
    ],

    activeDeletePrompt: false,
    votingDelete: null,
  }),
  components: {
    Datepicker,
    flatPickr,
  },
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    formatDateTime(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",

        hour: "2-digit",
        minute: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    customFormatDateTime(customDateTime) {
      let pattern = /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})/;

      let result = customDateTime.replace(pattern, "$3-$2-$1T$4:$5:00");
      return result;
    },
    addNewAnswer() {
      this.countNewAnswers++;
      this.newVoting.answers.push("");
    },
    removeNewAnswer(index) {
      this.countNewAnswers--;
      this.newVoting.answers.splice(index, 1);
    },
    createVoting() {
      let dateVoting = this.newVoting.date_predicted,
        fullYear = new Intl.DateTimeFormat("ru", { year: "numeric" }).format(
          dateVoting
        ),
        MM = new Intl.DateTimeFormat("ru", { month: "2-digit" }).format(
          dateVoting
        ),
        DD = new Intl.DateTimeFormat("ru", { day: "2-digit" }).format(
          dateVoting
        );

      let payload = {
        title: this.newVoting.title,
        description: this.newVoting.description,
        budget: this.newVoting.budget,
        finance_source: this.newVoting.finance_source,
        date_predicted: `${fullYear}-${MM}-${DD}`,
        answers: this.newVoting.answers,
        kind: ["default"],

        date_end: this.newVoting.is_auto_result
          ? `${this.customFormatDateTime(this.newVoting.date_end)}+03:00`
          : "2000-01-01T00:00:00+03",
        is_auto_result: this.newVoting.is_auto_result,
      };

      this.$load(async () => {
        let res = (await this.$api.votings.createVoting(payload)).data;

        if (res.id) {
          res.date_created = this.formatDate(res.date_created);

          this.votings.splice(0, 0, res);
          this.notification("Успешно", "Голосование создано", "success");
        } else {
          this.notification(
            "Ошибка",
            "Голосование не удалось создать",
            "danger"
          );
        }

        this.clearNewVoting();
      });
    },
    openStatistics(id) {
      let data = this.votings.find((x) => x.id == id);

      this.infoStatisticsData = data;

      this.activeStatisticsPrompt = !this.activeStatisticsPrompt;
    },
    openResult(id) {
      let data = this.votings.find((x) => x.id == id);

      this.infoStatisticsData = data;

      this.resultStatisticsData = this.getResult(data);

      this.activeResultPrompt = !this.activeResultPrompt;
    },
    getResult(data) {
      let max = 0,
        total = 0,
        answers = [],
        result = {};

      //Прохожу циклом по всем вариантам ответов
      //answer.votes_number - кол-во проголосовавших людей за каждый вариант ответа
      //сохраняю каждое votes_number отдельно в новый массив
      data.answers.forEach((answer) => {
        answers.push(answer.votes_number);
      });

      //Определяю теперь максимальное число и название варианта, который выиграл голосование
      max = Math.max.apply(null, answers);
      let maxText = data.answers.find((x) => x.votes_number == max).text;

      //Получил сколько всего людей приняло участие в голосовании
      total = data.total_votes;

      if (total > 0) {
        let x = max / total;

        result.percent = Math.round((x + Number.EPSILON) * 100);
        result.idVoting = data.id;
        result.text = maxText;

        return result;
      }
    },
    clearNewVoting() {
      this.newVoting = {
        title: "",
        description: "",
        budget: 0,
        finance_source: "",
        date_predicted: "",
        answers: [],
        kind: ["default"],
      };

      this.countNewAnswers = 0;

      this.activeCreatePrompt = !this.activeCreatePrompt;
    },
    closeVoting() {
      let payload = {
        result: this.resultStatisticsData.id,
        solution: this.resultStatisticsData.text,
      };

      this.$load(async () => {
        let res = await this.$api.votings.closeVoting(
          this.resultStatisticsData.idVoting,
          payload
        );

        if (res.status == 200) {
          this.notification("Успешно", "Голосование закрыто", "success");
        } else {
          this.notification(
            "Ошибка",
            "Голосование не удалось закрыть",
            "danger"
          );
        }
        this.activeResultPrompt = false;
      });
    },
    getAllVotings() {
      this.$vs.loading();

      this.$load(async () => {
        let res = (await this.$api.votings.getAllVotings()).data;

        res.forEach((voting) => {
          voting.date_created = this.formatDate(voting.date_created);
        });

        this.votings = res;
        this.$vs.loading.close();
      });
    },
    openModalDeleteVoting(idVoting) {
      try {
        this.votingDelete = this.votings.find((x) => x.id == idVoting);

        this.activeDeletePrompt = true;
      } catch (error) {
        this.notification("Ошибка", "Голосование не найдено", "danger");
        this.activeDeletePrompt = false;
      }
    },
    deleteVoting() {
      let idVoting = this.votingDelete.id;
      if (this.votingDelete !== null) {
        try {
          this.$load(async () => {
            let res = (await this.$api.votings.deleteVoting(idVoting)).data;

            let index = this.votings.indexOf(this.votingDelete);
            if (index !== -1) {
              this.votings.splice(index, 1);
            }

            this.notification("Успешно", "Голосование удалено", "success");
            this.activeDeletePrompt = false;
          });
        } catch (error) {
          this.notification(
            "Ошибка",
            "Не удалось удалить голосование",
            "danger"
          );
          this.activeDeletePrompt = false;
        }
      }
    },
  },
  created() {},
  mounted() {
    this.getAllVotings();
  },
};
</script>